import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { Navbar } from './components/navbar/navbar';
import { CommonModule } from '@angular/common';
import { ThemeService } from './services/theme.service';
import { UtmService } from './services/utm.service';
import { AnalyticsService } from './services/analytics.service';
import { SignupModal } from './components/signup-modal/signup-modal';
import { SignupModalService } from './services/signup-modal.service';
import { Subject, takeUntil, filter } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, Navbar, CommonModule, SignupModal],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit, OnDestroy {
  protected readonly title = 'nerd-marketing-site';
  showSignupModal = false;
  private readonly signupModal = inject(SignupModalService);
  private readonly router = inject(Router);
  private readonly destroy$ = new Subject<void>();

  constructor() {
    inject(ThemeService);
    inject(UtmService);          // captures UTMs from URL into sessionStorage immediately
    inject(AnalyticsService).init(); // starts PostHog + router page-view listener
  }

  ngOnInit(): void {
    this.signupModal.onOpen.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.showSignupModal = true;
    });

    // The app scrolls inside <main> (and the app-root host), not the window, so
    // Angular's built-in scrollPositionRestoration can't reset it. Reset the real
    // scroll container to the top on every completed navigation.
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.scrollToTop());
  }

  private scrollToTop(): void {
    document.querySelector('main')?.scrollTo({ top: 0, left: 0 });
    (document.querySelector('app-root') as HTMLElement | null)?.scrollTo({ top: 0, left: 0 });
    window.scrollTo({ top: 0, left: 0 });
  }

  get navbarTextColor(): string {
    return 'rgba(255,255,255,0.85)';
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  closeSignupModal(): void {
    this.showSignupModal = false;
  }
}
